export const FILES_FILTER_FIELD = 'files_filter';
export const SECTOR_FIELD = [FILES_FILTER_FIELD, 'sector_id'];
export const LINE_FIELD = [FILES_FILTER_FIELD, 'line_id'];
export const WORKSTATION_FIELD = [FILES_FILTER_FIELD, 'workstation_id'];
export const UPLOAD_DATE_FIELD = [FILES_FILTER_FIELD, 'upload_date'];
export const ORGANIZATION_FIELD = [FILES_FILTER_FIELD, 'organization_id'];
export const COMPANY_FIELD = [FILES_FILTER_FIELD, 'company_id'];
export const FIRST_PAGE = 1;
